"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectDocumentsIdBySiteId = exports.selectDocumentsBySiteId = void 0;
var _paulCorePackage = require("paul-core-package");
var _constants = require("../../utils/constants");
const selectDocumentsIdBySiteId = _ref => {
  var _dataReducer$document;
  let {
    [_constants.packageKey]: {
      dataReducer
    } = {},
    [_paulCorePackage.constants.packageKey]: {
      sites
    } = {}
  } = _ref;
  return (dataReducer === null || dataReducer === void 0 ? void 0 : (_dataReducer$document = dataReducer.documents.bySiteId) === null || _dataReducer$document === void 0 ? void 0 : _dataReducer$document[sites.activeSiteId]) || [];
};
exports.selectDocumentsIdBySiteId = selectDocumentsIdBySiteId;
const selectDocumentsBySiteId = _ref2 => {
  var _dataReducer$document2;
  let {
    [_constants.packageKey]: {
      dataReducer
    } = {},
    [_paulCorePackage.constants.packageKey]: {
      sites
    } = {}
  } = _ref2;
  const documentsId = (dataReducer === null || dataReducer === void 0 ? void 0 : (_dataReducer$document2 = dataReducer.documents.bySiteId) === null || _dataReducer$document2 === void 0 ? void 0 : _dataReducer$document2[sites.activeSiteId]) || [];
  return documentsId.map(id => dataReducer === null || dataReducer === void 0 ? void 0 : dataReducer.documents.byId[id]);
};
exports.selectDocumentsBySiteId = selectDocumentsBySiteId;